import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Environment {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        // this.debug = this.experience.debug

        // Debug
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder('environment')
        // }

        // Setup
        this.setSunLight()
        this.setExpoLights()
        this.setHemisphereLight()
        // this.setAmbientLights()
        // this.setEnvironmentMap()
    }

    setSunLight() {
        // this.sunLight = new THREE.DirectionalLight('#ffffff', 4)
        // this.sunLight = new THREE.DirectionalLight('#ffc459', 4)
        // this.sunLight = new THREE.DirectionalLight('#ffb859', 8)
        // this.sunLight = new THREE.DirectionalLight('#ffd69f', 10)
        this.sunLight = new THREE.DirectionalLight('#ffffff', 10)
        // this.sunLight2 = new THREE.DirectionalLight('#ffd69f', 5)
        this.sunLight.castShadow = true
        // this.sunLight.shadow.camera.far = 15
        // this.sunLight.shadow.mapSize.set(1024, 1024) // Increase this to get rid of choppy shadows boat or change type shadow?
        this.sunLight.shadow.mapSize.set(2048, 2048)
        // this.sunLight.shadow.mapSize.set(4096, 4096)

        // Shadow settings
        this.sunLight.shadow.radius = 5
        this.sunLight.shadow.blurSamples = 50
        this.sunLight.shadow.normalBias = 0.01 // Weird shadows boat, but if disabled, weird shadows water.
        this.sunLight.shadow.camera = new THREE.OrthographicCamera(-15, 15, 15, -15, 0.5, 50);


        // this.sunLight.position.set(3.5, 2, - 1.25)
        // this.sunLight.position.set(-3.7, 2, - 3.1)
        // this.sunLight.position.set(-35.7, 20, - 32.1)
        this.sunLight.position.set(-3.6, 5, 1.066)
        // this.sunLight2.position.set(-5.6, 5, 3.066)
        this.sunLight.target.position.set(0, 0, 2)
        // dirLight.target.updateMatrixWorld();
        this.sunLight.intensity = 4.5
        // this.scene.add(new THREE.DirectionalLightHelper(this.sunLight, 5));
        this.scene.add(this.sunLight)

        // this.scene.add(this.sunLight2)

        // Night?
        // this.hemiLight = new THREE.HemisphereLight(0x0000ff, 0xffb859, 1);
        // this.scene.add(this.hemiLight)


        // Debug
        // this.cubeGeometry = new THREE.BoxGeometry(0.05, 0.05, 0.05)
        // this.cubeMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00 })
        // this.cube = new THREE.Mesh(this.cubeGeometry, this.cubeMaterial);
        // this.cube.position.x = 3.12
        // this.cube.position.y = 0.3
        // this.cube.position.z = 0.32
        // this.scene.add(this.cube)
        // if (this.debug.active) {

        //     this.debugFolder
        //         .add(this.cube.position, 'x')
        //         .name('cubeX')
        //         .min(-10)
        //         .max(10)
        //         .step(0.01)

        //     this.debugFolder
        //         .add(this.cube.position, 'y')
        //         .name('cubeY')
        //         .min(-5)
        //         .max(5)
        //         .step(0.01)

        //     this.debugFolder
        //         .add(this.cube.position, 'z')
        //         .name('cubeZ')
        //         .min(-10)
        //         .max(10)
        //         .step(0.01)
        // }


        // if (this.debug.active) {
        //     this.debugFolder
        //         .add(this.sunLight, 'intensity')
        //         .name('sunLightIntensity')
        //         .min(0)
        //         .max(10)
        //         .step(0.001)

        //     this.debugFolder
        //         .add(this.sunLight.position, 'x')
        //         .name('sunLightX')
        //         .min(-10)
        //         .max(10)
        //         .step(0.1)

        //     this.debugFolder
        //         .add(this.sunLight.position, 'y')
        //         .name('sunLightY')
        //         .min(-50)
        //         .max(50)
        //         .step(1)

        //     this.debugFolder
        //         .add(this.sunLight.position, 'z')
        //         .name('sunLightZ')
        //         .min(-10)
        //         .max(10)
        //         .step(0.1)
        // }
    }

    setExpoLights() {
        // this.expoLights = new THREE.DirectionalLight('#ffd69f', 8)
        this.expoLights = new THREE.PointLight('#ffefd9', 10, 3)
        // this.expoLights.castShadow = true
        // this.expoLights.shadow.camera.far = 15
        // this.expoLights.shadow.mapSize.set(256, 256) // Doesn't do anything?
        // this.expoLights.shadow.normalBias = 0.05
        // this.expoLights.position.set(3.5, 2, - 1.25)
        this.expoLights.position.set(3.033, -0.9, 1.927)
        // this.expoLights.add(new THREE.AxesHelper(5))
        this.scene.add(this.expoLights)


        // Debug
        // if (this.debug.active) {
        //     this.debugFolder
        //         .add(this.expoLights, 'intensity')
        //         .name('expoLightsIntensity')
        //         .min(0)
        //         .max(10)
        //         .step(0.001)

        //     this.debugFolder
        //         .add(this.expoLights.position, 'x')
        //         .name('expoLightsX')
        //         .min(-5)
        //         .max(5)
        //         .step(0.001)

        //     this.debugFolder
        //         .add(this.expoLights.position, 'y')
        //         .name('expoLightsY')
        //         .min(-5)
        //         .max(5)
        //         .step(0.001)

        //     this.debugFolder
        //         .add(this.expoLights.position, 'z')
        //         .name('expoLightsZ')
        //         .min(-5)
        //         .max(5)
        //         .step(0.001)
        // }
    }

    setAmbientLights() {
        // Test light types
        this.ambientLights = new THREE.AmbientLight(0x404040)
        this.scene.add(this.ambientLights)
    }

    setHemisphereLight() {
        this.hemisphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 1)
        this.scene.add(this.hemisphereLight)


        // Debug
        // if (this.debug.active) {
        //     this.debugFolder
        //         .add(this.hemisphereLight, 'intensity')
        //         .name('hemisphereLightIntensity')
        //         .min(0)
        //         .max(10)
        //         .step(0.001)
        // }
    }

    setEnvironmentMap() {
        this.environmentMap = {}
        // this.environmentMap.intensity = 0.4
        this.environmentMap.intensity = 0.755

        this.environmentMap.texture = this.resources.items.environmentMapTexture
        this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace

        this.scene.environment = this.environmentMap.texture

        this.environmentMap.updateMaterials = () => {
            this.scene.traverse((child) => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                    child.material.envMap = this.environmentMap.texture
                    child.material.envMapIntensity = this.environmentMap.intensity
                    child.material.needsUpdate = true
                }
            })
        }
        this.environmentMap.updateMaterials()

        // Debug
        // if (this.debug.active) {
        //     this.debugFolder
        //         .add(this.environmentMap, 'intensity')
        //         .name('envMapIntensity')
        //         .min(0)
        //         .max(4)
        //         .step(0.001)
        //         .onChange(this.environmentMap.updateMaterials)
        // }
    }
}